import React, { useState } from 'react'
import { Button } from 'semantic-ui-react'
import NaviMenu from "./NaviMenu";
import NaviLink from "./NaviLink";
import Page from './Page';


function Navigator({ tenant, account, item, onCommit, onClose }) {
    const [histories, setHistories] = useState([]);
    const [currentItem, setCurrentItem] = useState(item);
    const [showRewind, setShowRewind] = useState(true);

    const currentMenu = tenant.menus.find(x => currentItem.kind === "menu" && x.code === currentItem.code);
    const currentLink = tenant.links.find(x => currentItem.kind === "link" && x.code === currentItem.code);

    const rewind = () => {
        setCurrentItem(histories.pop());
        setHistories(histories);
    }

    const forward = (nextItem) => {
        setHistories(histories.concat(currentItem));
        setCurrentItem(nextItem);
    }

    const onRewind = showRewind ? () => { (0 < histories.length) ? rewind() : onClose() } : null;

    return (
        <div>
            {currentMenu &&
                <Page title={currentMenu.name} onReset={onClose} onRewind={onRewind}>
                    <NaviMenu tenant={tenant} menu={currentMenu} onSelectChildMenu={x => forward({ kind: "menu", code: x.code })} onSelectLink={x => forward({ kind: "link", code: x.code })}></NaviMenu>
                </Page>
            }
            {currentLink &&
                <Page title={currentLink.name} onReset={onClose} onRewind={onRewind}>
                    <NaviLink tenant={tenant} account={account} link={currentLink} onCommit={onCommit} setShowRewind={setShowRewind} ></NaviLink>
                </Page>
            }
            {(!currentMenu && !currentLink) &&
                <div style={{ textAlign: "center" }}>
                    <Button onClick={onClose}>予約メニューを表示</Button>
                </div>
            }
        </div>
    );
}

export default Navigator;